<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="input-section form-section">
              <div style="margin-top: 30px;margin-bottom: 10px;">
                <label for class="orep-label">
                  <span class="qtn mrpx-5">3.</span> Total number of Employees:
                </label>
                <input
                    type="text"
                    name="totalNumberOfEmployees"
                    v-model="ppiApplication.totalNumberOfEmployees"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('totalNumberOfEmployees')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('totalNumberOfEmployees') | filterText }}</span>
              </div>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">4A.</span>Your Company’s Expected Annual Revenue:
                <span
                    class="help is-danger form-errors text-danger"
                >REQUIRED FIELD: Do NOT put Zero. (If newly licensed, please estimate.) </span>
              </label>
              <input
                  type="number"
                  min="1"
                  oninput="this.value=(parseInt(this.value)||0)"
                  class="orep-text-input w-100"
                  name="expectedAnnualRevenue"
                  v-validate="'required|numeric|min_value:1'"
                  @change="validateExpectedAnnualRevenue()"
                  @input="validateExpectedAnnualRevenue()"
                  v-model="ppiApplication.expectedAnnualRevenue"
              >
              <span
                  v-show="errors.has('expectedAnnualRevenue')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('expectedAnnualRevenue') | filterText }}</span>
              <label for class="orep-label" style="margin-top: 20px">
                <span class="qtn mrpx-5">4B.</span> Requested Limit of Liability
              </label>
              <div class="row">
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                          type="checkbox"
                          name="limitsOfLiability"
                          id="liability-one"
                          value="300K/600K"
                          class="orep-radio"
                          :checked="ppiApplication.limitsOfLiability.find(liability => liability === '300K/600K')"
                          v-validate="'required|included:300K/600K,500K/1M,1M/3M,1M/5M,2M/2M,3M/3M,4M/4M,5M/5M,CustomLimit'"
                          @change="validateBeforeSubmit() + limitsOfLiability($event)"
                      >
                      <span class="radio-span solo-checkbox-span">$300,000 / $600,000</span>
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                          type="checkbox"
                          name="limitsOfLiability"
                          id="liability-three"
                          value="500K/1M"
                          class="orep-radio"
                          :checked="ppiApplication.limitsOfLiability.find(liability => liability === '500K/1M')"
                          @change="validateBeforeSubmit() + limitsOfLiability($event)"
                      >
                      <span class="radio-span solo-checkbox-span">$500,000 / $1,000,000</span>
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                          type="checkbox"
                          name="limitsOfLiability"
                          id="liability-five"
                          value="1M/3M"
                          class="orep-radio"
                          :checked="ppiApplication.limitsOfLiability.find(liability => liability === '1M/3M')"
                          @change="validateBeforeSubmit() + limitsOfLiability($event)"
                      >
                      <span class="radio-span solo-checkbox-span">$1,000,000 / $3,000,000</span>
                    </label>
                  </div>
                </div>
                <span
                    v-show="errors.has('limitsOfLiability')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('limitsOfLiability') | filterText }}</span>
              </div>
              <div class="row" style="margin-top: 20px">
                <div class="col-md-12">
                  <label for class="orep-label">
                    Property Limits:
                  </label>
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">-</span> Base Policy includes $25,000 of Business Personal Property Coverage (Furniture & Fixtures) at no extra cost
                  </label>
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">-</span> Base Policy includes $25,000 of Business Income and Extra Expense at no extra cost
                  </label>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div style="margin-top: 30px;margin-bottom: 10px;">
                <label for class="orep-label">
                  <span class="qtn mrpx-5">5.</span> Annual Payroll:
                </label>
                <input
                    type="text"
                    name="annualPayroll"
                    v-model="ppiApplication.annualPayroll"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('annualPayroll')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('annualPayroll') | filterText }}</span>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">6.</span>
                    Does the applicant subcontract any investigative work?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="doesApplicantSubcontract"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="ppiApplication.doesApplicantSubcontract"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="doesApplicantSubcontract"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="ppiApplication.doesApplicantSubcontract"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('doesApplicantSubcontract')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('doesApplicantSubcontract') | filterText }}</span>
                </div>

              </div>
              <div class="flex wrap"
                   v-if="ppiApplication.doesApplicantSubcontract === 'true' || ppiApplication.doesApplicantSubcontract == true"
              >
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">6a.</span>If Yes - what is the amount paid to subcontractors (annually)?
                  </label></div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <input
                        type="text"
                        name="amountPaidToSubcontractors"
                        v-validate="'required'"
                        v-model="ppiApplication.amountPaidToSubcontractors"
                        class="orep-text-input"
                        @input="validateBeforeSubmit()"
                    >

                  </div>
                  <span
                      v-show="errors.has('amountPaidToSubcontractors')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('amountPaidToSubcontractors') | filterText }}</span>
                </div>
              </div>
              <div class="flex wrap"
                   v-if="ppiApplication.doesApplicantSubcontract === 'true' || ppiApplication.doesApplicantSubcontract == true"
              >
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">6b.</span>If Yes - Are subcontractors required to maintain their own liability coverage?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <input
                        type="text"
                        name="subcontractorsLiabilityCoverage"
                        v-validate="'required'"
                        v-model="ppiApplication.subcontractorsLiabilityCoverage"
                        class="orep-text-input"
                        @input="validateBeforeSubmit()"
                    >

                  </div>
                  <span
                      v-show="errors.has('subcontractorsLiabilityCoverage')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('subcontractorsLiabilityCoverage') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">7.</span>
                    Do you currently have liability insurance?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveLiabilityInsurance"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="ppiApplication.haveLiabilityInsurance"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveLiabilityInsurance"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="ppiApplication.haveLiabilityInsurance"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('haveLiabilityInsurance')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('haveLiabilityInsurance') | filterText }}</span>
                </div>

              </div>
              <div class="flex wrap"
                   v-if="ppiApplication.haveLiabilityInsurance === 'true' || ppiApplication.haveLiabilityInsurance == true"
              >
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">7a.</span>If Yes - When does your current policy expire?
                  </label></div>
                <div class="col-md-3 d-flex flex-column">
                    <datepicker
                        name="policyExpireDate"
                        v-model="ppiApplication.policyExpireDate"
                        v-validate="'required'"
                        format="MM/dd/yyyy"
                        input-class="orep-text-input col-md-12"
                        @input="validateBeforeSubmit()"
                        :disabled="state.policyExpireDate"
                        :clearButton="false"
                        :value="computedDates"
                    ></datepicker>

                  <span
                      v-show="errors.has('policyExpireDate')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('policyExpireDate') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">8.</span>
                    During the past five(5) years, has any claim been made or suit brought against the applicant?

                  </label>
                  <p>
                    (If Yes, please provide details on a separate attachment.)
                  </p>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="claimMadeInPast5Years"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="ppiApplication.claimMadeInPast5Years"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="claimMadeInPast5Years"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="ppiApplication.claimMadeInPast5Years"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('claimMadeInPast5Years')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('claimMadeInPast5Years') | filterText }}</span>
                </div>

              </div>

            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">9.</span>
                    Is the Applicant aware of any circumstance, allegation, contention, or incident which may result in a claim or
                    suit against the Applicant?
                  </label>
                  <p>
                    (If Yes, please provide details on a separate attachment.)
                  </p>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantAwareOfAnyCircumstance"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="ppiApplication.applicantAwareOfAnyCircumstance"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantAwareOfAnyCircumstance"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="ppiApplication.applicantAwareOfAnyCircumstance"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('applicantAwareOfAnyCircumstance')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('applicantAwareOfAnyCircumstance') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">10.</span>
                    Has any insurer canceled or refused to renew any similar insurance during the past five (5) years?
                  </label>
                  <p>(If Yes, please provide details on a separate attachment.)</p>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="insurerCanceledRefused5Years"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="ppiApplication.insurerCanceledRefused5Years"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="insurerCanceledRefused5Years"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="ppiApplication.insurerCanceledRefused5Years"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('insurerCanceledRefused5Years')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('insurerCanceledRefused5Years') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">11A.</span>
                    Does any operation require you to carry and/or use of a firearm? (IF YOU CARRY FOR YOUR OWN PROTECTION, ANSWER NO)
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="useOfFirm"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="ppiApplication.useOfFirm"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="useOfFirm"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="ppiApplication.useOfFirm"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('useOfFirm')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('useOfFirm') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">11B.</span>
                    Are you a licensed Private Investigator?
                  </label>
                </div>
                <div class="col-md-8 d-flex flex-column">
                  <div class="flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="licensedPrivateInvestigator"
                            value="yes"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="ppiApplication.licensedPrivateInvestigator"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="licensedPrivateInvestigator"
                            value="no"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="ppiApplication.licensedPrivateInvestigator"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="licensedPrivateInvestigator"
                            value="apply-license"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="ppiApplication.licensedPrivateInvestigator"
                        >
                        <span class="radio-span">Applying for License Now</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="licensedPrivateInvestigator"
                            value="not-required"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="ppiApplication.licensedPrivateInvestigator"
                        >
                        <span class="radio-span">Not Required</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('licensedPrivateInvestigator')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('licensedPrivateInvestigator') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">12.</span>
                    Please list the Professional Associations that you are a Member of:
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <select id="listOfProfessionalAssociations" v-model="ppiApplication.listOfProfessionalAssociations"
                            class="dropdown orep-text-input">
                      <option value="None">None</option>
                      <option v-for="option in options" :key="option">{{ option }}</option>
                    </select>
                  </div>
                  <span
                      v-show="errors.has('listOfProfessionalAssociations')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('listOfProfessionalAssociations') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label proposal-title blue-color"><strong>
                OPTIONAL Additional Coverages (for Additional Premium):</strong>
              </label>
              <div class="row">
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <p for class="orep-label">
                      <span class="qtn mrpx-6">-</span> $100K <a href="http://orep.org/100K-cyber-coverage-pi" target="_blank" class="coverage-link">
                      Cyber Liability</a>
                      (HIGHLY RECOMMENDED):
                    </p>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                          type="checkbox"
                          name="cyberTechnologyCoverage"
                          value
                          class="orep-radio position-relative"
                          v-model="ppiApplication.cyberTechnologyCoverage"
                          @change="validateBeforeSubmit()"
                      >
                      <span class="radio-span solo-checkbox-span">$125 Additional Premium</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">-</span> Waiver of Subrogation:
                    </label>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="waiverOfSubrogation"
                        value
                        class="orep-radio position-relative"
                        v-model="ppiApplication.waiverOfSubrogation"
                        @change="validateBeforeSubmit()"
                      >
                      <span class="radio-span solo-checkbox-span">$150 Additional Premium</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">-</span> Primary Wording:
                    </label>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                          type="checkbox"
                          name="primaryWording"
                          value
                          class="orep-radio position-relative"
                          v-model="ppiApplication.primaryWording"
                          @change="validateBeforeSubmit()"
                      >
                      <span class="radio-span solo-checkbox-span">$150 Additional Premium</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">-</span> Worldwide Coverage:
                  </label>
                </div>
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                          type="checkbox"
                          name="worldwideCoverage"
                          value
                          class="orep-radio position-relative"
                          v-model="ppiApplication.worldwideCoverage"
                          @change="validateBeforeSubmit()"
                      >
                      <span class="radio-span solo-checkbox-span">Will Add Additional Premium</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                <label for class="orep-label">
                  <span class="qtn mrpx-5">-</span> Hired and Non-Owned Auto:
                </label>
                </div>
                <div class="col-md-4">
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label>
                    <input
                        type="checkbox"
                        name="hireLimitLiability"
                        id="claim-limit-one"
                        value="50K/100K"
                        class="orep-radio"
                        :checked="ppiApplication.hireLimitLiability.find(liability => liability === '50K/100K')"
                        v-validate="'included:50K/100K'"
                        @change="validateBeforeSubmit() + hireLimitLiability($event)"
                    >
                    <span class="radio-span solo-checkbox-span">$50,000/$100,000</span>
                  </label>
                </div>
                </div>
              </div>
                <!-- <p>(Limit Selected cannot exceed primary liability limits)</p> -->
                <div v-if="ppiApplication.hireLimitLiability.find(liability => liability === '50K/100K')" class="flex wrap pb-3">
                  <div class="col-md-9">
                    <label for class="input-info">
                      <span class="mr-1">a. Does your firm currently have commercial auto insurance?</span>
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                              type="radio"
                              name="commercialAutoPolicyInPlace"
                              value="true"
                              class="orep-radio"
                              @change="validateBeforeSubmit()"
                              v-model="ppiApplication.commercialAutoPolicyInPlace"
                          >
                          <span class="radio-span">Yes</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                              type="radio"
                              name="commercialAutoPolicyInPlace"
                              value="false"
                              class="orep-radio"
                              @change="validateBeforeSubmit()"
                              v-model="ppiApplication.commercialAutoPolicyInPlace"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="ppiApplication.hireLimitLiability.find(liability => liability === '50K/100K')" class="flex wrap pb-3">
                  <div class="col-md-9">
                    <label for class="input-info">
                      <span class="mr-1">b. Does your firm hire or rent auto in excess of 10 times per year?</span>
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                              type="radio"
                              name="doesApplicantRentOrHireAuto10Time"
                              value="true"
                              class="orep-radio"
                              @change="validateBeforeSubmit()"
                              v-model="ppiApplication.doesApplicantRentOrHireAuto10Time"
                          >
                          <span class="radio-span">Yes</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                              type="radio"
                              name="doesApplicantRentOrHireAuto10Time"
                              value="false"
                              class="orep-radio"
                              @change="validateBeforeSubmit()"
                              v-model="ppiApplication.doesApplicantRentOrHireAuto10Time"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="ppiApplication.hireLimitLiability.find(liability => liability === '50K/100K')" class="flex wrap pb-3">
                  <div class="col-md-9">
                    <label for class="input-info">
                      <span class="mr-1">c. Does your firm ever use a vehicle to transport their clients?</span>
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                              type="radio"
                              name="doesApplicantUseAnyAuto"
                              value="true"
                              class="orep-radio"
                              @change="validateBeforeSubmit()"
                              v-model="ppiApplication.doesApplicantUseAnyAuto"
                          >
                          <span class="radio-span">Yes</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                              type="radio"
                              name="doesApplicantUseAnyAuto"
                              value="false"
                              class="orep-radio"
                              @change="validateBeforeSubmit()"
                              v-model="ppiApplication.doesApplicantUseAnyAuto"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="ppiApplication.hireLimitLiability.find(liability => liability === '50K/100K')" class="flex wrap pb-3">
                  <div class="col-md-9">
                    <label for class="input-info">
                      <span class="mr-1">d. Does your firm lease or own any vehicle registered in the firm’s name?</span>
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                              type="radio"
                              name="doesApplicantOwnAnyAuto"
                              value="true"
                              class="orep-radio"
                              @change="validateBeforeSubmit()"
                              v-model="ppiApplication.doesApplicantOwnAnyAuto"
                          >
                          <span class="radio-span">Yes</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                              type="radio"
                              name="doesApplicantOwnAnyAuto"
                              value="false"
                              class="orep-radio"
                              @change="validateBeforeSubmit()"
                              v-model="ppiApplication.doesApplicantOwnAnyAuto"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'ppi-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button @click="prev()" class="pagination-dots"></button>
            <button class="pagination-dots pagination-current"></button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid"
              @click="navigateToNext('ppi-application-3')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid ||!state.pageThreeIsValid "
              @click="navigateToNext('ppi-application-4')">
            </button>
            <button
                class="pagination-dots"
                @click="navigateToNext('ppi-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid|| !state.pageThreeIsValid || !state.pageFourIsValid">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageTwoIsValid"
                  :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('ppi-application-3')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";


export default {
  name: "ppi-application-2",
  computedDates() {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    ppiApplication() {
      return this.$store.state.ppiApplication.ppiApplication;
    },
    state() {
      return this.$store.state.ppiApplication;
    },
    errorMsg() {
      return this.$store.state.ppiApplication.errorMsg;
    },
    options() {
      return [
        "FALI",
        "CALI",
        "TALI",
        "FAPI",
        "MAPI",
        "NALI",
        "AALPI",
        "SCALI",
        "NCAPI",
        "APIA",
        "OTHER"
      ];
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    expectedAnnualRevenue(event) {
      if(!this.ppiApplication.expectedAnnualRevenue.find(revenue => revenue === event.target.value)) {
        if (this.ppiApplication.expectedAnnualRevenue.length < 1) {
          this.ppiApplication.expectedAnnualRevenue.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 1 option.'
          });
          event.target.checked = false
        }
      } else {
        this.ppiApplication.expectedAnnualRevenue = this.ppiApplication.expectedAnnualRevenue.filter(revenue => revenue !== event.target.value);
      }
    },
    personalPropertyCoverage(event) {
      if(!this.ppiApplication.personalPropertyCoverage.find(propertycoverage => propertycoverage === event.target.value)) {
          this.ppiApplication.personalPropertyCoverage.push(event.target.value);
      } else {
        this.ppiApplication.personalPropertyCoverage = this.ppiApplication.personalPropertyCoverage.filter(propertycoverage => propertycoverage !== event.target.value);
      }
    },
    limitsOfLiability(event) {
      if(!this.ppiApplication.limitsOfLiability.find(liability => liability === event.target.value)) {
        if (this.ppiApplication.limitsOfLiability.length < 1) {
          this.ppiApplication.limitsOfLiability.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 1 option.'
          });
          event.target.checked = false
        }
      } else {
        this.ppiApplication.limitsOfLiability = this.ppiApplication.limitsOfLiability.filter(liability => liability !== event.target.value);
      }
    },
    hireLimitLiability(event) {
      if(!this.ppiApplication.hireLimitLiability.find(liabilitylimit => liabilitylimit === event.target.value)) {
          this.ppiApplication.hireLimitLiability.push(event.target.value);
      } else {
        this.ppiApplication.hireLimitLiability = this.ppiApplication.hireLimitLiability.filter(liabilitylimit => liabilitylimit !== event.target.value);
      }
    },
    prev() {
      this.$router.push({
        name: "ppi-application-1"
      });
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateExpectedAnnualRevenue() {
      if (this.ppiApplication.expectedAnnualRevenue <= 0) {
        alert('Expected Annual Revenue must be greater than zero.');
        this.state.pageTwoIsValid = false;
        return false;
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },


    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
            this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {
    Datepicker
  }
};

</script>

<style scoped>
table td, table th {
  border: 1px solid black;
}
table th {
  height: 35px;
}
table td:not(:first-child), table th:not(:first-child) {
  text-align: center;
  max-width: 140px;
}
table input {
  width: 100%;
  text-align: center;
}
</style>
